<tabset>
    <tab *ngFor="let dashboard of siteType?.dashboards" [heading]="dashboard.name">
        <app-dashboard #dashboardViewer [delayLoad]="false" [dashboardId]="dashboard.dashboardId" [siteUri]="siteUri" [showEditor]="false"></app-dashboard>
    </tab>
</tabset>